import { Routes } from '@angular/router';
import { authGuard, loginGuard } from '../guards/auth.guard';

export const coreRoutes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    title: 'Anmeldung',
    loadComponent: () => import('./login/login').then(m => m.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    loadComponent: () => import('./dashboard/dashboard').then(m => m.DashboardComponent),
    canActivate: [authGuard],
  },
];
